import { EventEmitter, SimpleChanges } from '@angular/core';
import { COMPANY } from 'Angular/constants/core.constants';
import { DEFAULT_SECURITY_GROUP_TAB_OPTIONS, SECURITY_GROUP_TAB_LABEL_MAP, } from 'SecurityListsApp/ts/features/security-list-selector-modals/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
function SecurityListGroupTabsComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 2)(1, "a", 3);
    i0.ɵɵlistener("click", function SecurityListGroupTabsComponent_li_1_Template_a_click_1_listener() { const tab_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); ctx_r2.activeSecurityGroupTab = tab_r2.groupName; return i0.ɵɵresetView(ctx_r2.securityGroupChangeHandler.emit(ctx_r2.activeSecurityGroupTab)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r2.activeSecurityGroupTab === tab_r2.groupName);
    i0.ɵɵproperty("textContent", tab_r2.tabName);
} }
/**
 * Security List Group Tabs Component
 *
 * Manages the tabs for the different groups of security lists (Equities, Indicators, etc.)
 *
 * Input Properties:
 *  securityGroupTabOptions: SecurityGroupTabOption[] with the groupName and tabName for each tab that should be displayed
 *  activeSecurityGroupTab: SecurityGroupName that is the groupName for the currently selected tab
 *
 * Output Properties:
 *  securityGroupChangeHandler: Emits the new selectedSecurityGroup whenever it changes
 */
export class SecurityListGroupTabsComponent {
    constructor() {
        this.securityGroupTabOptions = DEFAULT_SECURITY_GROUP_TAB_OPTIONS;
        this.activeSecurityGroupTab = COMPANY;
        this.securityGroupChangeHandler = new EventEmitter();
        this.securityGroupTabLabels = [];
    }
    ngOnInit() {
        this.updateTabLabels();
    }
    ngOnChanges(changes) {
        if (changes?.securityGroupTabOptions?.currentValue) {
            this.updateTabLabels();
        }
    }
    updateTabLabels() {
        this.securityGroupTabLabels = [];
        SECURITY_GROUP_TAB_LABEL_MAP.forEach((label) => {
            if (this.securityGroupTabOptions.includes(label.groupName)) {
                this.securityGroupTabLabels.push(label);
            }
        });
    }
}
SecurityListGroupTabsComponent.ɵfac = function SecurityListGroupTabsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SecurityListGroupTabsComponent)(); };
SecurityListGroupTabsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SecurityListGroupTabsComponent, selectors: [["ycn-security-list-group-tabs"]], inputs: { securityGroupTabOptions: "securityGroupTabOptions", activeSecurityGroupTab: "activeSecurityGroupTab" }, outputs: { securityGroupChangeHandler: "securityGroupChangeHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[1, "nav", "nav-tabs", "justify-content-start", "user-select-none"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [1, "nav-item"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click", "textContent"]], template: function SecurityListGroupTabsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ul", 0);
        i0.ɵɵtemplate(1, SecurityListGroupTabsComponent_li_1_Template, 2, 3, "li", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.securityGroupTabLabels);
    } }, dependencies: [i1.NgForOf], encapsulation: 2 });
